const actions = {
    GET_DATA: "addresses/GET_DATA",
    SET_DATA: "addresses/SET_DATA",

    SET_INITIAL_ADDRESSES: "addresses/SET_INITIAL_ADDRESSES"
};

export default actions